export default {
  page_title: 'Universal promo codes',
  title: 'Universal promo codes',
  create_promo_code: 'Create promo code',
  info_banner:
    'Promo codes are intended for use in external channels like partner programs, email marketing, ads, or offline campaigns.',
  tabs: {
    overview: 'Overview',
    olo_config: 'Olo Config',
    active: 'Active',
    draft: 'Draft',
    complete: 'Complete',
  },
  active: {
    title: 'Active promo codes',
    description:
      'Active promo codes you can use across external campaigns and channels to distribute offers.',
  },
  draft: {
    empty: 'No draft promo codes.',
  },
  complete: {
    empty: 'No completed promo codes.',
  },
  empty_state: {
    title: 'No promo codes yet',
    description:
      'Create your first promo code to use across external campaigns and channels.',
  },
  table: {
    name: 'Name',
    promo_code: 'Promo code',
    redemptions: 'Redemptions',
    expiration: 'Expiration',
    view: 'View',
    no_end_date: 'No end date',
    unique_codes: '%{count} unique codes',
    generating_codes: 'Generating codes…',
    redemptions_count: '%{redeemed} / %{total} used',
    redemptions_single: '%{redeemed} used',
  },
  actions: {
    edit: 'Edit',
    end_promotion: 'End promotion',
    delete_draft: 'Delete',
    export_csv: 'Export codes (CSV)',
    exporting: 'Exporting...',
    download_csv: 'Download codes (CSV)',
    downloading: 'Downloading...',
    generating_csv: 'Generating CSV...',
    end_success: 'Promotion ended successfully.',
    end_error: 'Failed to end promotion.',
    delete_success: 'Draft deleted.',
    delete_error: 'Failed to delete draft.',
    export_queued:
      'CSV export queued. Refresh the row to see the download link.',
    export_error: 'Failed to export codes.',
    download_error: 'Could not download the CSV. Please try again.',
  },
  confirm_end: {
    title: 'End promotion',
    message:
      'Are you sure you want to end this promotion? This cannot be undone.',
    confirm: 'End promotion',
    ending: 'Ending...',
  },
  confirm_delete: {
    title: 'Delete draft?',
    message:
      'Are you sure you want to delete this draft? The promotion will be moved to the Complete tab.',
    confirm: 'Delete',
    deleting: 'Deleting...',
  },
}
